'use client';
import { hideOthers } from 'aria-hidden';
import { useEffect, useId, useMemo } from 'react';

function useAriaHidden(ref, shouldHide) {
  const currentElement = ref.current;
  useEffect(() => {
    if (!ref.current || !shouldHide)
      return void 0;
    return hideOthers(ref.current);
  }, [shouldHide, ref, currentElement]);
}
function useIds(idProp, ...prefixes) {
  const reactId = useId();
  const id = idProp || reactId;
  return useMemo(() => {
    return prefixes.map((prefix) => `${prefix}-${id}`);
  }, [id, prefixes]);
}

export { useAriaHidden, useIds };
